import { axios } from "./axiosSettings";
import { getAuthToken } from "../helpers/session.js";
import { logger } from "./logger";

export default class Agreement {
  static async getLatestAgreement() {
    try {
      const { data } = await axios.get(
        "/agreement",
        {
          headers: {
            Authorization: `Bearer ${getAuthToken()}`,
          },
        }
      );
      return { data };
    } catch (e) {
      logger.error(e);
      return { error: e.message };
    }
  }

  static async setAgreement(en, jp) {
  try {
    const { data } = await axios.post(
      "/agreement",
      {
        en,
        jp,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getAuthToken()}`,
        },
      }
    );

    return { data };
  } catch (e) {
    logger.error(e);
    return { error: e.message };
  }
  }
}
